import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, SimpleChanges} from '@angular/core';
import { ContractStepModel } from '../../../../models/contract.model';
import { STEPS_STYLING_MAP } from '../../models/contract-styling-consts';
import { TFormState } from '../../../../models/forms.model';
import { MatDialog } from '@angular/material/dialog';
import { AppContractFormComponent } from '../../controller/contract-form/contract-form.component';
import { Observable, Subscription } from 'rxjs';
import { AppContractStepTargetSelectComponent } from '../contract-step-target-select/contract-step-target-select.component';
import { IContractDataModel } from '../../models/contract-internal-models';
import { ContractDataService } from '../../services/contract-data.service';
import { ContractRoadMapService } from '../../services/contract-roadmap.service';
import { ContractAvatarsService } from '../../services/contract-avatar.service';
@Component({
    selector: 'app-contract-step-subcontract',
    templateUrl: './contract-step-subcontract.component.html',
    styleUrl: './contract-step-subcontract.component.scss',
    changeDetection:ChangeDetectionStrategy.OnPush,
 
})
export class AppContractStepSubContractComponent {
    private subs = new Subscription()
    @Input() public contractStep: ContractStepModel|null = null;
    @Input() public contractData: IContractDataModel|null = null;
    public formState:TFormState = 'Default'
    public stepsStylingMap = STEPS_STYLING_MAP;
    public notSingedMembers:string[]|undefined = []
    public singedMembers:string[]|undefined = []
    public steps$!:Observable<ContractStepModel[]|[]>
    constructor(
      private cds:ChangeDetectorRef,
      private dialog:MatDialog,
      private contractRoadMapService:ContractRoadMapService,
      private contractDataService:ContractDataService,
      public contractAvatarsService:ContractAvatarsService,
    ) {}
    ngOnDestroy(): void {
      this.subs.unsubscribe()
    }
    ngOnChanges(changes: SimpleChanges): void {
      this.contractStep?.target?.target_key? this.steps$ = this.contractRoadMapService.getSubContract(this.contractStep?.target?.target_key):null
      this.prepareAvatars()
      this.cds.detectChanges()
    }
    ngOnInit(): void {
      this.subs.add(
        this.contractDataService.subStepDataChanged.subscribe(data=>{
          data.step.target_key && data.step.target_type === 'sub_contract'? 
          this.steps$ = this.contractRoadMapService.getSubContract(data.step.target_key,false):null;          
          this.cds.detectChanges()
        })
      )
    }
    prepareAvatars() {
      this.notSingedMembers = this.contractStep?.membersAvatarsToShow?.filter(el=>el.state===false).map(el=>el.guid)
      this.singedMembers = this.contractStep?.membersAvatarsToShow?.filter(el=>el.state===true).map(el=>el.guid)
      this.cds.detectChanges()
    }
    viewSubContractInDialog() {
      if (this.contractStep?.target?.target_key) {
        let contractDialogRef = this.dialog.open(AppContractFormComponent, {
            maxWidth: '2000px',
            width: '94vw',
            minHeight: '96vh',
            height:'96vh',
            panelClass: 'contract-step-subcontract-modalbox'
        });
        contractDialogRef.componentInstance.contractGuid = this.contractStep?.target?.target_key
        contractDialogRef.componentInstance.openAsDialog = true;
        contractDialogRef.componentInstance.verifyDomainOnLoad = false
      }
    }
    addSubContract() {
    let stepSelectModal = this.dialog.open(AppContractStepTargetSelectComponent,{
          minWidth: '80vw',
          maxHeight: '95vh',
          panelClass: 'project-select-padding-modalbox'
    })
    
    stepSelectModal.componentInstance.roadmap = this.contractData?.contract?.roadmap_active?.steps!
    stepSelectModal.componentInstance.step = this.contractStep! 
    stepSelectModal.componentInstance.dialogToClose = stepSelectModal
    stepSelectModal.componentInstance.contractGuid = this.contractData?.contract?.contract.guid!

    stepSelectModal.afterClosed().subscribe(()=>this.cds.detectChanges())
    }
}